import { DeleteWorkspacePage } from '@/features/privacy/delete-workspace-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
export const Route = createFileRoute(
  '/_authed/dashboard/settings/delete-account'
)({
  validateSearch: z.object({
    confirm: z.boolean().optional().catch(undefined),
  }),
  component: () => (
    <DeleteWorkspacePage confirm={Route.useSearch().confirm === true} />
  ),
});
